module.exports = {
      id: "new-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#new",
      toString: function () {
        return this.url;
      }
    }